export enum MspSortType {
    CASE_ID = 'case-id',
    CASE_TYPE = 'case-type',
    INCIDENT_DATE = 'incident-date',
}
export enum MspSortDirection {
    ASC = 'asc',
    DESC = 'desc'
}
export interface MspSortForm {
    sortType: MspSortType
    sortDirection: MspSortDirection
}
